import { render } from "./PrizesBlock.vue?vue&type=template&id=1beb476c&scoped=true"
import script from "./PrizesBlock.vue?vue&type=script&lang=js"
export * from "./PrizesBlock.vue?vue&type=script&lang=js"

import "./PrizesBlock.vue?vue&type=style&index=0&id=1beb476c&lang=less&scoped=true"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1beb476c"]])

export default __exports__